import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MetricOption, MetricInputModalData, MetricInputModalResult } from './metric-input-modal.model';

@Component({
  selector: 'bhub-metric-input-modal',
  templateUrl: './metric-input-modal.component.html',
  styleUrls: ['./metric-input-modal.component.scss'],
  standalone: false
})
export class MetricInputModalComponent implements OnInit {
  selectedMetric: MetricOption | null = null;
  unit: string = '';
  defaultColor: string = '#000000';

  unitOptions = [
    { value: '', label: 'None' },
    { value: '$', label: 'Dollar ($)' },
    { value: '%', label: 'Percent (%)' }
  ];

  constructor(
    public dialogRef: MatDialogRef<MetricInputModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MetricInputModalData
  ) {
    if (data.initialValue) {
      this.selectedMetric = data.initialValue.selectedMetric;
      this.unit = data.initialValue.unit;
      this.defaultColor = data.initialValue.defaultColor;
    }
  }

  ngOnInit(): void {
    // If no initial metric selected, select first available
    if (!this.selectedMetric && this.data.availableMetrics.length > 0) {
      this.selectedMetric = this.data.availableMetrics[0];
    }
  }

  getPreviewValue(): string {
    if (!this.selectedMetric) return 'Select a metric';
    
    let value = '1,234.56'; // Sample value
    
    // Apply unit prefix/suffix
    if (this.unit) {
      if (this.unit === '$') {
        value = this.unit + value;
      } else {
        value = value + this.unit;
      }
    }

    return value;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (!this.selectedMetric) {
      return;
    }

    const result: MetricInputModalResult = {
      selectedMetric: this.selectedMetric,
      unit: this.unit,
      defaultColor: this.defaultColor
    };

    this.dialogRef.close(result);
  }

  isValidInput(): boolean {
    return this.selectedMetric !== null;
  }
}